<ph-field [formGroup]="formGroup" class="animated fadeIn">
    <ph-label>Check number</ph-label>
    <ph-input
        type="text"
        [formControlName]="controlName"
        ngDefaultControl
        [placeholder]="placeholder"
        (input)="limitToNumbers()"
        [hasError]="control?.touched && control?.value && control?.invalid"
    ></ph-input>
    <lf-control-messages [control]="control"></lf-control-messages>
</ph-field>
